<div class="pcl-shell" (click)="fecharDropdown()">
  <div *ngIf="mensagemCentral"
       style="position:fixed;inset:0;z-index:2000000;display:flex;align-items:center;justify-content:center;pointer-events:none">
    <div style="background:rgba(30,41,59,0.85);color:#fff;padding:8px 18px;border-radius:8px;font-size:12.5px;font-weight:500;box-shadow:0 4px 16px rgba(0,0,0,0.2);text-align:center">
      {{ mensagemCentral }}
    </div>
  </div>
  <div class="container">

    <!-- ── PAGE HEADER (mesmo padrão da Venda) ── -->
    <div class="page-header">
      <div class="page-header-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>
          <line x1="3" y1="6" x2="21" y2="6"/>
          <path d="M16 10a4 4 0 0 1-8 0"/>
        </svg>
      </div>
      <div style="flex:1">
        <h1>Pré-Compras</h1>
        <p>Consulte e acompanhe as pré-compras geradas</p>
      </div>
      <button type="button" class="btn-novo" (click)="novoPedido.emit()">
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
        </svg>
        Nova Pré-Compra
      </button>
    </div>

    <!-- ── FILTROS ── -->
    <div class="filtros-bar">

      <!-- Busca rápida — fornecedor/CNPJ/comprador -->
      <div class="filtro-busca-rapida filtro-busca-rapida--destaque">
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
        <input type="text" class="input-busca-rapida"
               placeholder="Filtrar por código, fornecedor, CNPJ ou comprador..."
               [(ngModel)]="termoBusca"
               (ngModelChange)="onTermoBuscaChange()">
        <button *ngIf="termoBusca" type="button" class="busca-limpar" (click)="termoBusca=''; onTermoBuscaChange()">✕</button>
      </div>

      <!-- Busca por PN / Descrição -->
      <div class="filtro-busca-rapida filtro-busca-pn">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
        <input type="text" class="input-busca-rapida"
               placeholder="Buscar por PN ou descrição..."
               [(ngModel)]="termoBuscaPn"
               (ngModelChange)="onTermoBuscaPnChange()">
        <button *ngIf="termoBuscaPn" type="button" class="busca-limpar" (click)="termoBuscaPn=''; buscar()">✕</button>
      </div>

      <!-- Separador -->
      <div class="filtro-divisor"></div>

      <div class="filtro-grupo">
        <label>De</label>
        <input type="date" class="input-data" [(ngModel)]="dtDe">
      </div>
      <div class="filtro-grupo">
        <label>Até</label>
        <input type="date" class="input-data" [(ngModel)]="dtAte">
      </div>
      <button type="button" class="btn-buscar" (click)="buscar()" [disabled]="carregando">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
        {{ carregando ? 'Buscando...' : 'Buscar' }}
      </button>

      <!-- Separador -->
      <div class="filtro-divisor"></div>

      <!-- Checkbox cancelados -->
      <label class="filtro-toggle" (click)="$event.stopPropagation()">
        <input type="checkbox" [(ngModel)]="mostrarCancelados" (ngModelChange)="onMostrarCanceladosChange()">
        <span class="toggle-label">Exibir cancelados</span>
      </label>
    </div>

    <!-- ── ERRO ── -->
    <div *ngIf="erro" class="alerta alerta-erro">{{ erro }}</div>

    <!-- ── TABELA ── -->
    <div class="tabela-card">
      <div *ngIf="carregando" class="loading-row">
        <div class="spinner"></div>
        <span>Carregando pré-compras...</span>
      </div>

      <div *ngIf="!carregando && pedidosFiltrados.length === 0" class="vazio-row">
        Nenhuma pré-compra encontrada.
      </div>

      <ng-container *ngIf="!carregando && pedidosFiltrados.length > 0">
        <table class="tabela">
          <thead>
            <tr>
              <th class="th-ordenavel" (click)="ordenar('nunota')" title="Clique para ordenar">Código<span class="th-seta" [class.th-seta-ativa]="ordenarCampo==='nunota'">{{ ordenarCampo==='nunota' ? (ordenarAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span></th>
              <th class="col-center th-ordenavel" (click)="ordenar('status')" title="Clique para ordenar">Status<span class="th-seta" [class.th-seta-ativa]="ordenarCampo==='status'">{{ ordenarCampo==='status' ? (ordenarAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span></th>
              <th class="col-center th-ordenavel" (click)="ordenar('codemp')" title="Clique para ordenar">Empresa<span class="th-seta" [class.th-seta-ativa]="ordenarCampo==='codemp'">{{ ordenarCampo==='codemp' ? (ordenarAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span></th>
              <th class="col-center th-ordenavel" (click)="ordenar('tipo')" title="Clique para ordenar">Tipo<span class="th-seta" [class.th-seta-ativa]="ordenarCampo==='tipo'">{{ ordenarCampo==='tipo' ? (ordenarAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span></th>
              <th class="th-ordenavel" (click)="ordenar('dtmov')" title="Clique para ordenar">Solicitação<span class="th-seta" [class.th-seta-ativa]="ordenarCampo==='dtmov'">{{ ordenarCampo==='dtmov' ? (ordenarAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span></th>
              <th class="th-ordenavel" (click)="ordenar('comprador')" title="Clique para ordenar">Solicitante<span class="th-seta" [class.th-seta-ativa]="ordenarCampo==='comprador'">{{ ordenarCampo==='comprador' ? (ordenarAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span></th>
              <th class="th-ordenavel" (click)="ordenar('observacao')" title="Clique para ordenar">Observação<span class="th-seta" [class.th-seta-ativa]="ordenarCampo==='observacao'">{{ ordenarCampo==='observacao' ? (ordenarAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span></th>
              <th class="th-ordenavel" (click)="ordenar('numPo')" title="Clique para ordenar">Número PO<span class="th-seta" [class.th-seta-ativa]="ordenarCampo==='numPo'">{{ ordenarCampo==='numPo' ? (ordenarAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span></th>
              <th class="th-ordenavel" (click)="ordenar('numOrdem')" title="Clique para ordenar">Número Ordem<span class="th-seta" [class.th-seta-ativa]="ordenarCampo==='numOrdem'">{{ ordenarCampo==='numOrdem' ? (ordenarAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span></th>
              <th class="th-ordenavel" (click)="ordenar('numCotacao')" title="Clique para ordenar">Número Cotação<span class="th-seta" [class.th-seta-ativa]="ordenarCampo==='numCotacao'">{{ ordenarCampo==='numCotacao' ? (ordenarAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span></th>
              <th class="th-ordenavel" (click)="ordenar('fornecedor')" title="Clique para ordenar">Fornecedor<span class="th-seta" [class.th-seta-ativa]="ordenarCampo==='fornecedor'">{{ ordenarCampo==='fornecedor' ? (ordenarAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span></th>
              <th class="col-right th-ordenavel" (click)="ordenar('vlr')" title="Clique para ordenar">Valor R$<span class="th-seta" [class.th-seta-ativa]="ordenarCampo==='vlr'">{{ ordenarCampo==='vlr' ? (ordenarAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span></th>
              <th class="col-right th-ordenavel" (click)="ordenar('vlrusd')" title="Clique para ordenar">Valor U$<span class="th-seta" [class.th-seta-ativa]="ordenarCampo==='vlrusd'">{{ ordenarCampo==='vlrusd' ? (ordenarAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span></th>
              <th class="th-ordenavel th-quebra" (click)="ordenar('idsPedCompra')" title="Pedidos de Compra vinculados a esta pré-compra (Nº Sankhya)">Pedidos Vinc.<span class="th-seta" [class.th-seta-ativa]="ordenarCampo==='idsPedCompra'">{{ ordenarCampo==='idsPedCompra' ? (ordenarAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span></th>
              <th class="th-ordenavel" style="white-space:nowrap;max-width:none" (click)="ordenar('pcpIdAerosys')" title="Clique para ordenar">Nº Pré-Compra Aerosys<span class="th-seta" [class.th-seta-ativa]="ordenarCampo==='pcpIdAerosys'">{{ ordenarCampo==='pcpIdAerosys' ? (ordenarAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span></th>
              <th class="col-center col-acoes-th">Ações</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let p of pedidosPagina">
            <tr class="linha-clicavel" [class.linha-cancelada]="p.status === 'Cancelado'"
                [class.linha-selecionada]="pedidoSelecionado === p.nunota"
                (click)="selecionarLinha($event, p)"
                (dblclick)="onDblClickLinha(p)" title="Clique para selecionar | Duplo clique para editar">
              <td class="col-nunota"><a class="link-itens" (click)="abrirItens($event, p)" (dblclick)="$event.stopPropagation()" title="Clique para ver os itens da pré-compra">{{ p.nunota }}</a></td>
              <td class="col-center">
                <span class="status-badge" [ngClass]="statusLegadoClass(p.gplStatus)">{{ p.gplStatus || '—' }}</span>
              </td>
              <td class="col-center">
                <span class="empresa-badge"
                  [style.background]="empresa.corClaraPorCodEmp(p.codemp, 0.82)"
                  [style.border-left]="'3px solid ' + empresa.corPorCodEmp(p.codemp)"
                  [title]="p.empresa">{{ fmtCodEmp(p.codemp) }}</span>
              </td>
              <td class="col-center">
                <span class="tipo-badge" [ngClass]="tipoClass(p.tipoGpl)">{{ fmtTipo(p.tipoGpl) }}</span>
              </td>
              <td class="col-data">{{ p.dtmov }}</td>
              <td class="col-vend" [title]="p.comprador">{{ p.comprador }}</td>
              <td class="col-obs">
                <span class="obs-texto" [title]="p.observacao">{{ p.observacao }}</span>
              </td>
              <td class="col-vend" [title]="p.numPo">{{ p.numPo || '—' }}</td>
              <td class="col-vend" [title]="p.numOrdem">{{ p.numOrdem || '—' }}</td>
              <td class="col-vend" [title]="p.numCotacao">{{ p.numCotacao || '—' }}</td>
              <td class="col-cliente" [title]="p.fornecedor">{{ p.fornecedor }}</td>
              <td class="col-right col-valor">{{ fmtBrl(vlrTotal(p)) }}</td>
              <td class="col-right col-valor">{{ fmtUsd(vlrTotalUsd(p)) }}</td>
              <td class="col-center col-pedvinc" [title]="p.idsPedCompra">{{ p.idsPedCompra || '—' }}</td>
              <td class="col-center col-pedaero">{{ p.pcpIdAerosys ?? '—' }}</td>
              <td class="col-center col-acoes" (click)="$event.stopPropagation()" (dblclick)="$event.stopPropagation()">
                <div class="dropdown-wrapper">
                  <button class="btn-dots" [class.btn-dots-ativo]="dropdownAberto === p.nunota" (click)="toggleDropdown($event, p)" title="Ações">⋮</button>
                  <div class="dropdown-menu" *ngIf="dropdownAberto === p.nunota" (click)="$event.stopPropagation()">
                    <div class="dropdown-header">Pré-Compra #{{ p.nunota }}</div>
                    <button class="dropdown-item item-editar"
                      (click)="editarPedido.emit(p.nunota); dropdownAberto = null">
                      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                      {{ podeEditar(p) ? 'Editar Pré-Compra' : 'Visualizar Pré-Compra' }}
                    </button>
                    <div class="dropdown-separador"></div>
                    <div class="dropdown-subtitulo">Status</div>
                    <button class="dropdown-item" [disabled]="!podeAutorizar(p)" (click)="alterarStatus(p, 'AUTORIZAR')">Autorizar</button>
                    <button class="dropdown-item" [disabled]="!podeCancelarPedido(p)" (click)="alterarStatus(p, 'CANCELAR')">Cancelar pré-compra</button>
                    <button class="dropdown-item" [disabled]="!podeEstornar(p)" (click)="alterarStatus(p, 'ESTORNAR')">Estornar</button>
                    <div class="dropdown-separador"></div>
                    <button class="dropdown-item" [disabled]="!podeCancelarItensEmAberto(p)"
                      [title]="podeCancelarItensEmAberto(p) ? '' : 'Disponível apenas para pré-compras com status BACKORDERS'"
                      (click)="cancelarItensAbertos(p)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>
                      Cancelar itens em aberto
                    </button>
                    <button class="dropdown-item" [disabled]="!podeCancelarItemSelecionado(p)"
                      [title]="tituloCancelarItemSelecionado(p)" (click)="cancelarItemSelecionado(p)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>
                      {{ rotuloCancelarSelecionados(p) }}
                    </button>
                    <div class="dropdown-separador"></div>
                    <button class="dropdown-item" [disabled]="!podeReabrirItens(p)"
                      [title]="tituloReabrirItens(p)" (click)="reabrirTodosItens(p)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/></svg>
                      Reabrir todos os itens cancelados
                    </button>
                    <button class="dropdown-item" [disabled]="!podeReabrirItemSelecionado(p)"
                      [title]="tituloReabrirItemSelecionado(p)" (click)="reabrirItemSelecionado(p)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/></svg>
                      {{ rotuloReabrirSelecionados(p) }}
                    </button>
                    <div class="dropdown-separador"></div>
                    <button class="dropdown-item" (click)="abrirPrevisaoEntrega(p, 'todos')">
                      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                      Inserir previsão de entrega em todos os itens
                    </button>
                    <button class="dropdown-item" [disabled]="!podePrevisaoSelecionado(p)"
                      [title]="tituloPrevisaoSelecionado(p)" (click)="abrirPrevisaoEntrega(p, 'selecionado')">
                      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                      Inserir previsão de entrega no(s) item(ns) selecionado(s)
                    </button>
                    <div class="dropdown-separador"></div>
                    <button class="dropdown-item" (click)="abrirGerarPreVenda(p)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="12" y1="18" x2="12" y2="12"/><line x1="9" y1="15" x2="15" y2="15"/></svg>
                      Gerar Pré-Venda
                    </button>
                    <button *ngFor="let relatorio of relatoriosImpressao" class="dropdown-item"
                      (click)="imprimirPedido.emit({nunota: p.nunota, view: relatorio.view}); dropdownAberto = null">
                      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9V3h12v6"/><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect x="6" y="14" width="12" height="8"/></svg>
                      {{ relatorio.titulo }}
                    </button>
                  </div>
                </div>
              </td>
            </tr>
            <!-- Expansao: itens do pedido (abre abaixo da linha, igual ao Fluxo do Pedido de Venda) -->
            <tr *ngIf="itensAberto && itensNunota === p.nunota" class="linha-itens-expansao">
              <td colspan="16" class="td-itens">
                <div class="itens-container-inline">
                  <div class="itens-corpo">
                    <div class="itens-vazio" *ngIf="itensCarregando">Carregando itens...</div>
                    <div class="itens-vazio itens-erro" *ngIf="!itensCarregando && itensErro">{{ itensErro }}</div>
                    <div class="itens-vazio" *ngIf="!itensCarregando && !itensErro && itens.length === 0">Pré-Compra sem itens.</div>
                    <div class="itens-scroll" *ngIf="!itensCarregando && itens.length > 0">
                      <table class="itens-tabela">
                        <thead>
                          <tr>
                            <th class="col-center" style="width:28px"><input type="checkbox" [checked]="todosItensMarcados" (click)="toggleTodosItens($event)" title="Marcar todos"></th>
                            <th class="col-center">ORD</th>
                            <th>PN</th>
                            <th class="col-center">UN</th>
                            <th class="col-right">QTD</th>
                            <th>FABRICANTE</th>
                            <th class="col-right">ESTOQUE</th>
                            <th class="col-center">CD</th>
                            <th class="col-right" title="Qtde Vendida no período (Aerosys + Sankhya)">QTDE VENDIDA</th>
                            <th class="col-right" title="Qtde Vendida no mesmo período do ano anterior">VEND. ANO ANT.</th>
                            <th class="col-right" title="Ponto de Pedido (Aerosys)">PONTO PEDIDO</th>
                            <th class="col-right" title="Qtde em outros Pedidos de Compra abertos (Aerosys)">QTDE OUTROS PED.</th>
                            <th class="col-right" title="Qtde em PréCompra Aberto/BackOrders (Aerosys)">QTDE PRÉCOMPRA AB/BK</th>
                            <th class="col-right" title="Estoque EUA (Aerosys)">ESTOQUE EUA</th>
                            <th class="col-right" title="Custo = Preço do Fabricante (U$)">CUSTO U$</th>
                            <th class="col-right" title="Custo U$ × cotação do dia">CUSTO R$</th>
                            <th class="col-right">TOTAL U$</th>
                            <th class="col-right">TOTAL R$</th>
                            <th>OBSERVAÇÃO</th>
                            <th>DESCRIÇÃO</th>
                            <th class="col-center" title="Previsão de entrega do item">PREVISÃO ENTREGA</th>
                            <th class="col-center">STATUS</th>
                            <th class="col-center" title="Código interno do produto (CODPROD)">ID</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let it of itens; let i = index" class="itens-linha" [class.itens-linha-sel]="itensMarcados.has(i)" (click)="selecionarItem(i, $event)">
                            <td class="col-center"><input type="checkbox" [checked]="itensMarcados.has(i)" (click)="selecionarItem(i, $event)"></td>
                            <td class="col-center">{{ it.sequencia || i + 1 }}</td>
                            <td style="cursor:pointer" title="Clique para copiar o PN" (click)="copiarPn(it.pn, $event)">{{ it.pn }}</td>
                            <td class="col-center">{{ it.unidade }}</td>
                            <td class="col-right">{{ it.quantidade | number:'1.0-4':'pt-BR' }}</td>
                            <td class="itens-desc" [title]="it.fabricante || ''">{{ it.fabricante || '—' }}</td>
                            <td class="col-right" [class.itens-est-zero]="!it.estoque">{{ it.estoque == null ? '—' : (it.estoque | number:'1.0-3':'pt-BR') }}</td>
                            <td class="col-center">{{ it.cd || '—' }}</td>
                            <td class="col-right">{{ it.qtdeVendas ?? '—' }}</td>
                            <td class="col-right">{{ it.qtdeVendasAnoAnt ?? '—' }}</td>
                            <td class="col-right">{{ it.pontoPedido ?? '—' }}</td>
                            <td class="col-right" [title]="it.pedidoOutros || ''">{{ it.qtdePedidoOutros ?? '—' }}</td>
                            <td class="col-right" [title]="it.dataPrecompraAbBk || ''">{{ it.qtdePrecompraAbBk ?? '—' }}</td>
                            <td class="col-right">{{ it.estoqueEua ?? '—' }}</td>
                            <td class="col-right">{{ it.custoUsd > 0 ? fmtDec(it.custoUsd) : '—' }}</td>
                            <td class="col-right">{{ it.custoBrl > 0 ? fmtDec(it.custoBrl) : '—' }}</td>
                            <td class="col-right">{{ it.totalUsd > 0 ? fmtDec(it.totalUsd) : '—' }}</td>
                            <td class="col-right">{{ it.totalBrl > 0 ? fmtDec(it.totalBrl) : '—' }}</td>
                            <td class="itens-desc" [title]="it.obs || ''">{{ it.obs || '—' }}</td>
                            <td class="itens-desc" [title]="it.descricao || ''">{{ it.descricao }}</td>
                            <td class="col-center">{{ it.previsaoEntrega || '—' }}</td>
                            <td class="col-center"><span class="itens-status" [ngClass]="statusLegadoClass(it.statusItem || 'ABERTO')">{{ it.statusItem || 'ABERTO' }}</span></td>
                            <td class="col-center">{{ it.codprodInterno || '—' }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
            </ng-container>
          </tbody>
        </table>

        <!-- ── RODAPÉ: total + paginação ── -->
        <div class="tabela-rodape">
          <span class="rodape-total">{{ pedidosFiltrados.length }} pré-compra{{ pedidosFiltrados.length !== 1 ? 's' : '' }}</span>

          <div class="rodape-paginacao">
            <div class="por-pagina">
              <span>Exibir</span>
              <select [(ngModel)]="itensPorPagina" (ngModelChange)="onItensPorPaginaChange()" class="sel-pagina">
                <option *ngFor="let op of opcoesPorPagina" [value]="op">{{ op }}</option>
              </select>
              <span>por página</span>
            </div>

            <div class="pag-controles">
              <button class="pag-btn" (click)="irParaPagina(1)" [disabled]="paginaAtual === 1" title="Primeira">«</button>
              <button class="pag-btn" (click)="irParaPagina(paginaAtual - 1)" [disabled]="paginaAtual === 1" title="Anterior">‹</button>

              <ng-container *ngFor="let p of paginas">
                <button class="pag-btn" [class.pag-ativo]="p === paginaAtual" (click)="irParaPagina(p)">{{ p }}</button>
              </ng-container>

              <button class="pag-btn" (click)="irParaPagina(paginaAtual + 1)" [disabled]="paginaAtual === totalPaginas" title="Próxima">›</button>
              <button class="pag-btn" (click)="irParaPagina(totalPaginas)" [disabled]="paginaAtual === totalPaginas" title="Última">»</button>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

  </div>

  <!-- Modal: Gerar Pré-Venda a partir da Pré-Compra -->
  <div class="prev-overlay" *ngIf="gvAberto" (click)="fecharGerarPreVenda(); $event.stopPropagation()">
    <div class="prev-box gv-box" (click)="$event.stopPropagation()">
      <div class="prev-titulo">Gerar Pré-Venda</div>
      <div class="prev-sub">Pré-Compra #{{ gvPre?.nunota }} &nbsp;·&nbsp; {{ gvStep === 1 ? 'Passo 1 de 2 — escolha a empresa' : 'Passo 2 de 2 — itens e quantidades' }}</div>

      <!-- Passo 1: empresa (o cliente é o parceiro da própria empresa) -->
      <ng-container *ngIf="gvStep === 1">
        <div class="dup-empresas-wrap">
          <label class="dup-label">Gerar na empresa</label>
          <div class="dup-empresas-grid">
            <button *ngFor="let e of gvEmpresasOpcoes" type="button" class="dup-empresa-card"
                    [class.dup-empresa-card--ativa]="gvEmpresaSel === e.codEmp"
                    [style.background]="empresa.corClaraPorCodEmp(e.codEmp, 0.80)"
                    [style.border-color]="gvEmpresaSel === e.codEmp ? empresa.corPorCodEmp(e.codEmp) : 'transparent'"
                    (click)="gvTrocarEmpresa(e.codEmp)" [disabled]="gvGerando || gvCarregando">
              <span class="dup-emp-dot" [style.background]="empresa.corPorCodEmp(e.codEmp)"></span>
              <span class="dup-emp-cod">{{ e.codEmp }}</span>
              <span class="dup-emp-nome">{{ e.nomeFant || e.razaoAbrev }}</span>
            </button>
          </div>
        </div>
        <div class="gv-info" *ngIf="gvCarregando">Carregando...</div>
        <div class="gv-info" *ngIf="!gvCarregando && gvNomeCliente && !gvErro">Cliente da Pré-Venda: <strong>{{ gvNomeCliente }}</strong></div>
        <div class="prev-erro" *ngIf="gvErro">{{ gvErro }}</div>
        <div class="prev-acoes">
          <button type="button" class="prev-btn" (click)="fecharGerarPreVenda()">Cancelar</button>
          <button type="button" class="prev-btn prev-btn-ok" (click)="gvStep = 2"
                  [disabled]="gvCarregando || !!gvErro || gvCodParc <= 0 || gvItens.length === 0">Continuar</button>
        </div>
      </ng-container>

      <!-- Passo 2: itens -->
      <ng-container *ngIf="gvStep === 2">
        <div class="gv-info" *ngIf="gvNomeCliente">Empresa {{ gvEmpresaSel }} &nbsp;·&nbsp; Cliente: <strong>{{ gvNomeCliente }}</strong></div>
        <div class="prev-erro" *ngIf="gvErro">{{ gvErro }}</div>
        <div class="gv-scroll" *ngIf="gvItens.length > 0">
          <table class="gv-tabela">
            <thead>
              <tr>
                <th style="width:28px"><input type="checkbox" [checked]="gvTodosMarcados" (change)="gvToggleTodos()" [disabled]="gvGerando"></th>
                <th>PN</th><th>Descrição</th><th style="text-align:right">Qtd</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let i of gvItens">
                <td><input type="checkbox" [(ngModel)]="i.marcado" [disabled]="gvGerando"></td>
                <td>{{ i.pn }}</td>
                <td class="gv-desc" [title]="i.descricao">{{ i.descricao }}</td>
                <td style="text-align:right">
                  <input type="number" class="gv-qtd" min="0" [max]="i.qtdMax" step="1" [(ngModel)]="i.qtd" [disabled]="!i.marcado || gvGerando">
                  <span class="gv-max">/ {{ i.qtdMax }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="gv-info" *ngIf="gvItens.length > 0">Os preços são os de venda atuais de cada peça; a Pré-Venda nasce ABERTA.</div>
        <div class="prev-acoes">
          <button type="button" class="prev-btn" (click)="gvStep = 1" [disabled]="gvGerando">Voltar</button>
          <button type="button" class="prev-btn prev-btn-ok" (click)="confirmarGerarPreVenda()" [disabled]="gvGerando || gvCarregando || gvMarcados === 0">{{ gvGerando ? 'Gerando...' : 'Gerar Pré-Venda (' + gvMarcados + ')' }}</button>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- Modal: Previsão de entrega -->
  <div class="prev-overlay" *ngIf="previsaoModalAberto" (click)="fecharPrevisaoEntrega(); $event.stopPropagation()">
    <div class="prev-box" (click)="$event.stopPropagation()">
      <div class="prev-titulo">Previsão de entrega</div>
      <div class="prev-sub">{{ previsaoEscopo === 'todos' ? 'Será aplicada em todos os itens da pré-compra #' + previsaoPre?.nunota : 'Será aplicada somente nos itens selecionados da pré-compra #' + previsaoPre?.nunota }}</div>
      <input type="date" class="prev-data" [(ngModel)]="previsaoData" [disabled]="previsaoSalvando">
      <div class="prev-erro" *ngIf="previsaoErro">{{ previsaoErro }}</div>
      <div class="prev-acoes">
        <button type="button" class="prev-btn" (click)="fecharPrevisaoEntrega()" [disabled]="previsaoSalvando">Cancelar</button>
        <button type="button" class="prev-btn prev-btn-ok" (click)="confirmarPrevisaoEntrega()" [disabled]="previsaoSalvando">{{ previsaoSalvando ? 'Gravando...' : 'Confirmar' }}</button>
      </div>
    </div>
  </div>

  <!-- Diálogo padrão (confirmações e resultados das ações) -->
  <div class="pc-dlg-overlay" *ngIf="dialogo" (click)="fecharDialogo(false)">
    <div class="pc-dlg-modal" (click)="$event.stopPropagation()" role="dialog" aria-modal="true">
      <div class="pc-dlg-icon" [ngClass]="'pc-dlg-' + dialogo.tipo">
        <svg *ngIf="dialogo.tipo === 'sucesso'" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
        <svg *ngIf="dialogo.tipo === 'erro'" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>
        <svg *ngIf="dialogo.tipo === 'aviso' || dialogo.tipo === 'confirmar'" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
          <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
        </svg>
      </div>
      <h3 class="pc-dlg-titulo">{{ dialogo.titulo }}</h3>
      <p class="pc-dlg-msg">{{ dialogo.mensagem }}</p>
      <ul class="pc-dlg-detalhes" *ngIf="dialogo.detalhes.length">
        <li *ngFor="let d of dialogo.detalhes">{{ d }}</li>
      </ul>
      <div class="pc-dlg-footer">
        <button type="button" class="pc-dlg-btn" *ngIf="dialogo.tipo === 'confirmar'" (click)="fecharDialogo(false)">Cancelar</button>
        <button type="button" class="pc-dlg-btn-primary" [class.pc-dlg-btn-perigo]="dialogo.perigo"
          (click)="fecharDialogo(true)">{{ dialogo.textoConfirmar }}</button>
      </div>
    </div>
  </div>

</div>
